import React from 'react';
import MarkdownIt from 'markdown-it';

import tokensToAST from './tokens-to-ast';
import { cleanupTokens, groupTextTokens, getUniqueID, escapeCode } from './md-utils';

import mentionPlugin from './plugins/mention';
import emojiPlugin from './plugins/emoji';
import taskPlugin from './plugins/task';

const stringToTokens = (source, markdownIt) => {
    try {
        return markdownIt.parse(source, {});
    } catch (err) {
        console.error(err);
    }

    return [];
}

const rootRenderRule = (children, styles) => <React.Fragment key={getUniqueID()}>{children}</React.Fragment>;

const getRenderFunction = (type, rules) => {
    const renderFunction = rules[type];

    if (!renderFunction) {
        throw new Error(
            `${type} renderRule not defined.`
        );
    }
    return renderFunction;
};

/**
*
* @param node
* @param parentNodes
* @return {*}
*/
const renderNode = (node, parentNodes, rules, styles) => {
    const renderFunction = getRenderFunction(node.type, rules);

    const parents = [...parentNodes];
    parents.unshift(node);

    if (node.type === 'text') {
        return renderFunction(node, [], parentNodes, styles);
    }

    const children = node.children.map(value => {
        return renderNode(value, parents, rules, styles);
    });

    return renderFunction(node, children, parentNodes, styles);
};

/**
 *
 * @param {string} source
 * @param {function} [renderer]
 * @param {AstRenderer} [markdownIt]
 * @return {View}
 */
export default (source, rules, styles, projectNiceIds = [], disabledRules = []) => {
    const md = new MarkdownIt({
        typographer: true,
        linkify: true,
        breaks: true
    })
    .use(mentionPlugin)
    .use(emojiPlugin)
    .use(taskPlugin)
    .disable(disabledRules);

    md.customResources = { projectNiceIds };

    const withNewLines = escapeCode(source, escapedSource => {
        return escapedSource.replace(/\n\n(?=\n)/g, '\n<nifty-new-line-element>\n<nifty-new-line-element>');
    });

    let tokens = stringToTokens(withNewLines, md);
    tokens = cleanupTokens(tokens);
    tokens = groupTextTokens(tokens);

    const astTree = tokensToAST(tokens);

    md.renderer.render = (tokens, options, env) => {
        const children = tokens.map(value => renderNode(value, [], rules, styles));

        return rootRenderRule(children, styles);
    }

    return md.renderer.render(astTree);
}
